module.exports = __webpack_public_path__ + "img/suche.d562ef13.svg";